<template>
	<div>
		<v-row align="center">
			<v-col class="font-type text-left headline">
				{{ title }}
			</v-col>
			<v-col class="text-right">
				<slot name="top-actions"></slot>
			</v-col>
			<v-col cols="12">
				<v-checkbox
					dense
					hide-details
					small
					class="my-1 py-1 ml-4"
					v-model="allRegions"
					label="Ver todas las regiones"
				>
				</v-checkbox>
				<div class="d-flex">
					<v-select
						v-model="region"
						:disabled="allRegions"
						:items="regiones"
						item-text="region"
						item-value="region"
						dense
						solo
						filled
						outlined
						autocomplete="off"
						persistent-hint
						hint="Selecione la región"
						class="mr-2"
						style="max-width: 250px;"
					>
					</v-select>
					<v-text-field
						dense
						filled
						solo
						outlined
						hide-details
						append-icon="mdi-magnify"
						label="Buscar establecimiento"
						@input="e => setFilter(e)"
						style="max-width: 250px;"
					></v-text-field>
				</div>
			</v-col>

			<v-col>
				<v-chip-group column class="p-0" @change="setPlacesSelected">
					<v-chip
						filter
						value="domicilio"
						color="info"
						class="ma-1"
						v-if="domicilioPlaces.length"
					>
						<v-avatar left class="info darken-4">
							{{ domicilioPlaces.length }}
						</v-avatar>
						Domicilio
					</v-chip>

					<v-chip
						filter
						value="empresa"
						color="info"
						class="ma-1"
						v-if="empresaPlaces.length"
					>
						<v-avatar left class="info darken-4">
							{{ empresaPlaces.length }}
						</v-avatar>
						Empresa
					</v-chip>
				</v-chip-group>
				<places-document-chip :chips-list="chipsList" :onChangeChips="onChangeChips" />
				<div class="warning--text caption text-left">{{ warningMessage }}</div>
			</v-col>
		</v-row>
		<div v-if="places.length" class="maxHeightListPlace">
			<v-list two-line class="backgroundTransparent">
				<template v-for="item in placesSelected">
					<place-item :key="item._id + title" :item="item" />
				</template>
			</v-list>
		</div>
		<v-card flat v-if="!places.length" height="60" class="text-center">
			<v-card-text class="headline">
				<v-icon large left>mdi-account-circle</v-icon>{{ msjnodata }}
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import regiones from '@/assets/comunas-regiones.json';
import { mapGetters, mapMutations } from 'vuex';

export default {
	name: 'PlaceList',
	components: {
		PlaceItem: () => import('@/components/place/PlaceItem.vue'),
		placesDocumentChip: () => import('@/components/place/PlaceDocumentChip.vue'),
	},
	props: {
		title: { type: String, default: () => '' },
		msjnodata: { type: String, default: () => '' },
		places: { type: Array, default: () => [] },
		empresaPlaces: { type: Array, default: () => [] },
		domicilioPlaces: { type: Array, default: () => [] },
		mySharedPlaces: { type: Array, default: () => [] },
		myOwnedPlaces: { type: Array, default: () => [] },
		chipsList: { type: Array, default: () => [] },
		onChangeChips: { type: Function, required: true },
		setFilter: { type: Function, required: true },
		warningMessage: { type: String, default: '' },
	},
	data() {
		return {
			allRegions: true,
			regiones,
			placesSelected: [],
		};
	},
	mounted() {
		this.setPlacesSelected();
	},
	computed: {
		region: {
			get() {
				return this.regionSelecionada;
			},
			set(newValue) {
				this.setRegionFilter(newValue);
			},
		},
		...mapGetters({
			regionSelecionada: 'Place/regionSelecionada',
		}),
	},
	methods: {
		setPlacesSelected(value) {
			switch (value) {
				case 'created':
					this.placesSelected = this.myOwnedPlaces;
					break;
				case 'shared':
					this.placesSelected = this.mySharedPlaces;
					break;
				case 'all':
					this.placesSelected = this.places;
					break;
				case 'domicilio':
					this.placesSelected = this.domicilioPlaces;
					break;
				case 'empresa':
					this.placesSelected = this.empresaPlaces;
					break;
				default:
					this.placesSelected = this.places;
					break;
			}
		},
		...mapMutations({
			setRegionFilter: 'Place/setRegionFilter',
		}),
	},
	watch: {
		allRegions(newVal) {
			if (newVal) this.region = null;
		},
		places() {
			this.setPlacesSelected();
		},
	},
};
</script>
<style media="screen">
.maxHeightListPlace {
	max-height: 500px;
	overflow-y: auto;
}
</style>
